import React from 'react';

import { useAppAuth } from 'src/hooks/auth';
import { useCurrentUser, useCurrentUserPermissions } from 'src/hooks/user';
import { ROUTES_TREE } from 'src/routes';
import type { RouteProps } from 'src/types/router';
import { routesTreeChecker } from 'src/utils/router';

export const useRoutes = (): RouteProps[] => {
  const { isAuthorized } = useAppAuth();

  const { isPartnershipCompanyUser } = useCurrentUser();
  const userPermissions = useCurrentUserPermissions();

  const routes = React.useMemo(() => {
    if (userPermissions.loading) return [];
    return routesTreeChecker(ROUTES_TREE, isAuthorized, userPermissions, {
      isPartnershipCompanyUser,
    });
  }, [isAuthorized, userPermissions, isPartnershipCompanyUser]);

  return routes;
};
